var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-outer"},[_c('van-nav-bar',{attrs:{"title":"详情","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"con-outer"},[_c('instance-preview',{attrs:{"node-id":_vm.nodeId,"instance-id":_vm.instanceId},on:{"handler-after":_vm.handlerAfter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }